import React, { useState, FC, useEffect } from 'react';
import { UnifiedKeypoints } from '@exerai/vision-engine-web';
import { SideGaitResultsInsights } from '@/common/types';
import { useResultsInsights } from './hooks/ResultsInsights';
import { PhasePositionMarker } from './styles';

interface ResultsInsightsProps {
    resultsInsights: SideGaitResultsInsights;
    poseLog: UnifiedKeypoints[];
    frame: number;
    imageWidth: number;
}

export const SideGaitResultsInsightsOverlay: FC<ResultsInsightsProps> = ({
    resultsInsights,
    poseLog,
    frame,
    imageWidth,
}) => {
    const [showLap1ResultsInsights, setShowLap1ResultsInsights] = useState(false);
    const [showLap2ResultsInsights, setShowLap2ResultsInsights] = useState(false);
    const { lap1CycleStartX, lap1StepStartX, lap1CycleEndX, lap2CycleStartX, lap2StepStartX, lap2CycleEndX } =
        useResultsInsights(resultsInsights, poseLog);

    useEffect(() => {
        const { lapInfo } = resultsInsights;
        if (!lapInfo) {
            return;
        }
        if (frame >= lapInfo.lap1StartFrame && frame <= lapInfo.lap1EndFrame) {
            setShowLap1ResultsInsights(true);
        } else {
            setShowLap1ResultsInsights(false);
        }
        if (frame >= lapInfo.lap2StartFrame && frame <= lapInfo.lap2EndFrame) {
            setShowLap2ResultsInsights(true);
        } else {
            setShowLap2ResultsInsights(false);
        }
    }, [resultsInsights, frame]);

    return (
        <>
            {showLap1ResultsInsights && (
                <>
                    {lap1CycleStartX && (
                        <PhasePositionMarker $ratio={lap1CycleStartX / imageWidth} $color={'rgba(45, 193, 187, .5)'} />
                    )}
                    {lap1StepStartX && (
                        <PhasePositionMarker $ratio={lap1StepStartX / imageWidth} $color={'rgba(236, 240, 240, 0.5)'} />
                    )}
                    {lap1CycleEndX && (
                        <PhasePositionMarker $ratio={lap1CycleEndX / imageWidth} $color={'rgba(45, 193, 187, 1)'} />
                    )}
                </>
            )}
            {showLap2ResultsInsights && (
                <>
                    {lap2CycleStartX && (
                        <PhasePositionMarker $ratio={lap2CycleStartX / imageWidth} $color={'rgba(45, 193, 187, .5)'} />
                    )}
                    {lap2StepStartX && (
                        <PhasePositionMarker $ratio={lap2StepStartX / imageWidth} $color={'rgba(236, 240, 240, 0.5)'} />
                    )}
                    {lap2CycleEndX && (
                        <PhasePositionMarker $ratio={lap2CycleEndX / imageWidth} $color={'rgba(45, 193, 187, 1)'} />
                    )}
                </>
            )}
        </>
    );
};
